// react hot loader causes component
// equality checks to fail. However it provides a work around function
// areComponentsEqual
export var areComponentsEqual = function areComponentsEqual(a, b) {
  return a === b;
};
export var configureAreComponentsEqual = function configureAreComponentsEqual(fn) {
  return areComponentsEqual = fn;
};